// extracted by mini-css-extract-plugin
module.exports = {"overlay":"ub","bodyOpen":"vb","content":"wb","header":"xb","close":"yb","closeNoHeading":"zb"};